var App = App || {},
    navOpen = false;

App.Base = (function ($) {
    "use strict";

    function init() {
        Sticky();
        Tooltips();
    }

    function Sticky() {
        var $stickyElements = $(".position-sticky, .sticky-top");

        if ($stickyElements.length) {
            Stickyfill.add($stickyElements);
        }
    }

    function Tooltips() {
        $('[data-toggle="tooltip"]').tooltip({
            container: "body"
        });
    }

    return {
        init: init
    }

})(jQuery);

$(function () {
    App.Base.init();
});